// Acces aux avis, partage par toutes les pages.
// Un seul appel reseau par visite : le resultat est garde en memoire et les
// composants qui s'abonnent sont prevenus quand il arrive ou quand il change.

const ETAT = { charge: false, enCours: false, avis: [], total: 0, moyenne: null, configure: null };
const abonnes = new Set();

function prevenir() {
  abonnes.forEach((f) => {
    try { f(instantane()); } catch (e) { /* un abonne casse n'empeche pas les autres */ }
  });
}

export function instantane() {
  return {
    charge: ETAT.charge,
    avis: ETAT.avis,
    total: ETAT.total,
    moyenne: ETAT.moyenne,
    configure: ETAT.configure,
  };
}

export function sAbonner(f) {
  abonnes.add(f);
  return () => abonnes.delete(f);
}

export async function chargerAvis(forcer = false) {
  if (ETAT.enCours) return instantane();
  if (ETAT.charge && !forcer) return instantane();
  ETAT.enCours = true;
  try {
    const r = await fetch('/api/avis', { headers: { Accept: 'application/json' } });
    if (r.ok) {
      const d = await r.json();
      ETAT.avis = Array.isArray(d.avis) ? d.avis : [];
      ETAT.total = d.total || 0;
      ETAT.moyenne = d.moyenne;
      ETAT.configure = d.configure !== false;
    } else {
      ETAT.configure = false;
    }
  } catch (e) {
    // Hors ligne, ou fonction indisponible : le site reste consultable.
    ETAT.configure = false;
  }
  ETAT.charge = true;
  ETAT.enCours = false;
  prevenir();
  return instantane();
}

export function encoder(donnees) {
  return Object.keys(donnees)
    .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(donnees[k]))
    .join('&');
}
